var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('pendo-input',{staticClass:"string-input",class:(_vm.field + "-string-input"),attrs:{"placeholder":_vm.placeholder,"value":_vm.value,"debounce":""},on:{"input":_vm.onInputChange}})}
var staticRenderFns = []

export { render, staticRenderFns }